import React from 'react';
import { Unplug } from 'lucide-react';
import botspotLogo from '../../../assets/botspot_logo_horizontal.png';
import type { AuthFirstDesignProps } from './types';
import './TacticalLedger.css';

export default function TacticalLedger({
  authContent,
  subheading,
  titleId,
}: AuthFirstDesignProps): React.ReactElement {
  return (
    <div className="auth-first-design--tactical-ledger">
      <div className="tactical-ledger__frame">
        <header className="tactical-ledger__masthead">
          <img
            alt="BotSpot by LumiWealth"
            className="tactical-ledger__logo"
            height={429}
            src={botspotLogo}
            width={1385}
          />
        </header>

        <span aria-hidden="true" className="tactical-ledger__mobile-mark">
          <img alt="" height={429} src={botspotLogo} width={1385} />
        </span>

        <div className="tactical-ledger__grid">
          <div className="tactical-ledger__product-column">
            <div className="tactical-ledger__intro">
              <span className="tactical-ledger__eyebrow">BotSpot workspace</span>
              <h1 className="tactical-ledger__title" id={titleId}>
                Build your trading bot.{' '}
                <span className="tactical-ledger__title-span">Backtest before going live.</span>
              </h1>
              <div className="tactical-ledger__subheading-container">{subheading}</div>
            </div>

            <section aria-label="BotSpot workflow" className="tactical-ledger__workflow">
              <ol>
                <li>
                  <span aria-hidden="true">01</span>
                  <strong>Describe</strong>
                  <p>Write strategy rules in plain English.</p>
                </li>
                <li>
                  <span aria-hidden="true">02</span>
                  <strong>Inspect</strong>
                  <p>Review generated Python before anything runs.</p>
                </li>
                <li>
                  <span aria-hidden="true">03</span>
                  <strong>Backtest</strong>
                  <p>Test on historical data, then refine.</p>
                </li>
              </ol>
            </section>

            <div className="tactical-ledger__note-container">
              <Unplug
                aria-hidden="true"
                className="tactical-ledger__note-icon"
                focusable="false"
                size={13}
                strokeWidth={1.8}
              />
              <span className="tactical-ledger__note-text">
                No broker connection required to build or backtest.
              </span>
            </div>
          </div>

          <div className="tactical-ledger__auth-column">
            <div className="tactical-ledger__auth-body">{authContent}</div>
          </div>
        </div>
      </div>
    </div>
  );
}
